export default "__VITE_ASSET__45864934__"